module.exports = "import React from 'react';\n\nimport Slider from '~/components/slider';\n\nclass Example extends React.Component {\n\tstatic displayName = 'SliderExample';\n\n\trender() {\n\t\treturn <Slider id=\"disabled-id\" label=\"Slider Label\" disabled />;\n\t}\n}\n\nexport default Example;\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/@salesforce/design-system-react/components/slider/__examples__/disabled.jsx
// module id = 922
// module chunks = 0